import qs from "qs";
import {apiVoissa} from "../../libs/api";


export const createReport = (data, config = {}) => apiVoissa.post(`/reports`, data, config);

export const fetchReportReasons = (query = {}, config = {}) => apiVoissa.get(`/reports/report-raisons?${qs.stringify(query)}`, config);


export const REPORT_REASONS_KEY = `report-reasons`;